import React from 'react'
import { Row, Card, Separator, Bleed, LayoutBand, useContainerWidth } from '@fs/zion-ui'
import { ContentLock, ContentUnlock } from '@fs/zion-icon'
import { getCustomImage, getDuration } from '../helpers'
import VideoThumbnail from './CardListItem/VideoThumbnail'
import { MonoText } from '../type'
import { StrongLink } from '../link'
import Timestamp from '../Timestamp'
import { useHeadingLevel } from '../../hooks'

const Badges = ({ badges, conferenceYear, date }) => {
  return (
    <Row>
      <div growX>
        <Row gutters="nano" wrap>
          {badges}
        </Row>
      </div>
      <Row guttersX="none">
        <Timestamp conferenceYear={conferenceYear} timestamp={date} />
      </Row>
    </Row>
  )
}

const ThumbnailContainer = ({ data, to }) => {
  const { title } = data
  const thumbnailLinkName = `${title}: Thumbnail`
  const videoDuration = getDuration(data)
  const thumbnail = getCustomImage(data)
  return (
    <LayoutBand>
      <Card to={to} linkName={thumbnailLinkName} maxWidth={100}>
        <Bleed all>
          <VideoThumbnail thumbnail={thumbnail} duration={videoDuration} heading={title} />
        </Bleed>
      </Card>
    </LayoutBand>
  )
}

const ResponsiveContainer = ({ thumbnail, badges, children }) => {
  const atWidth = useContainerWidth()
  const dense = atWidth({ default: true, md: false })

  return dense ? (
    <Card>
      <Row>
        {thumbnail}
        {badges}
      </Row>
      {children}
    </Card>
  ) : (
    <Card>
      <Row>
        {thumbnail}
        <div growX>
          {badges}
          {children}
        </div>
      </Row>
    </Card>
  )
}

export default function HorizontalCard({
  data,
  to,
  actions,
  body,
  badges,
  isLocked,
  isUnlocked,
  conferenceYear,
  date,
  headingLevel = 'h3',
}) {
  const { Heading } = useHeadingLevel(headingLevel)
  const { title } = data

  const linkName = `${title}: Title`

  return (
    <ResponsiveContainer
      thumbnail={<ThumbnailContainer data={data} to={to} />}
      badges={<Badges badges={badges} conferenceYear={conferenceYear} date={date} />}
    >
      <Separator size="xxs" />
      <Row gutters="xs">
        <Heading size="H5">
          <MonoText>
            <StrongLink to={to} noUnderline linkName={linkName}>
              {title}
            </StrongLink>
          </MonoText>
        </Heading>
        {isLocked && <ContentLock color="gray" size="sm" />}
        {isUnlocked && <ContentUnlock color="gray" size="sm" />}
      </Row>
      <Separator size="xxs" />
      {body}
      {actions}
    </ResponsiveContainer>
  )
}
